import React, { Component } from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";

class bookList extends Component {
	constructor(props) {
		super(props);


		this.state = { totalcount: 0, curpageidx: 0, sortway: 1, sortorder: 1, booklist: [], loading: true };
		this.dofetchdata(true);

		this.doSort = this.doSort.bind(this);


	}

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
				console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.dofetchdata(false);
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}

	dofetchdata(binit) {

		if (binit === false && this.state.booklist.length >= this.state.totalcount)
			return;

		this.state.loading = true;
		//alert(JSON.stringify(this.state.sortway + ", " + this.state.sortorder));


		
		fetch(`/api/AB/BookList?pgidx=${this.state.curpageidx}&pgsize=50&orderby=${this.state.sortorder}&orderway=${this.state.sortway}`)
			.then(response => response.json())
			.then(data => {
				//this.setState({ forecasts: data, loading: false });
				//alert(JSON.stringify(data));
				//alert(data.totalcount);
				//this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.state.loading = false;

				if (binit === true) {
					this.state.curpageidx = 0;
					this.state.booklist = data.lstresult;
					this.state.curpageidx++;
				}
				else {
					this.state.curpageidx++;
					this.state.booklist.push(...data.lstresult);
				}

				//alert(data.lstresult);

				//this.state.booklist.push(...data.lstresult);

				//alert(this.state.booklist);

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
				//this.dorender();
			});

	}

	doSort(e) {
		var ns = e.currentTarget.name;
		var sortway = 1;
		var sortorder = 1;
		if (ns === 1) {
			sortway = 0;
			sortorder = 0;
		}
		else if (ns === 2) {
			sortway = 0;
			sortorder = 1;
		}
		else if (ns === 4) {
			sortway = 1;
			sortorder = 0;
		}
		else if (ns === 3) {
			sortway = 1;
			sortorder = 1;
		}
		this.state.sortorder = sortorder;
		this.state.sortway = sortway;

		this.dofetchdata(true);
	}

	dorender() {
		//alert(JSON.stringify(this.state));
		let bookDummy = this.state.booklist;
		//alert(JSON.stringify(bookDummy));

		return (
				bookDummy.map((book, index) => {
					return (
						<React.Fragment>
							<li className="bookList-item">
								<Link to={`/book/${book.id}`}>
									<div className="bookList-thumbnail">
										<div className="thumbnail">
											<img
												className="thumbnail-image"
												src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
												alt={book.subject}
											/>
										</div>
									</div>
									<div className="bookList-info">
										<h3 className="bookList-title">{book.subject}</h3>
										<h4 className="bookList-author">{book.authorName}</h4>
										<h4 className="bookList-publisher">{book.publisherName}</h4>
									</div>
								</Link>
							</li>
						</React.Fragment>
					);
				})
		);
	}

	render() {

		let contents = this.state.loading === true ? "loading..." : this.dorender();

		return (
			<React.Fragment>

				<ExpansionPanelDetails>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<div className="form-group">
								<h4 className="form-label">정렬</h4>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="1">
									ㄱ-ㅎ 순
								</Button>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="2">
									ㅎ-ㄱ 순
								</Button>
								&nbsp;&nbsp;
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="3">
									최신순
								</Button>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="4">
									역순
								</Button>
							</div>
						</Grid>
					</Grid>
				</ExpansionPanelDetails>
				
				<ul className="bookList">
					{contents}
				</ul>
			</React.Fragment>
		);
	}
}

export default bookList;
